import * as React from "react";
import { Icon } from "components/common";
const StepTitleWarning = ({ invalidStepKeys, stepKey }) => {
  if (invalidStepKeys == null ? void 0 : invalidStepKeys.includes(stepKey)) {
    return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Icon, { name: "warning" }), " ");
  }
  return null;
};
export default StepTitleWarning;
